export const months = [
  { id: 1, name: 'Январь' },
  { id: 2, name: 'Февраль' },
  { id: 3, name: 'Март' },
  { id: 4, name: 'Апрель' },
  { id: 5, name: 'Май' },
  { id: 6, name: 'Июнь' },
  { id: 7, name: 'Июль' },
  { id: 8, name: 'Август' },
  { id: 9, name: 'Сентябрь' },
  { id: 10, name: 'Октябрь' },
  { id: 11, name: 'Ноябрь' },
  { id: 12, name: 'Декабрь' },
];

const nowDate = new Date();

export const years = Array.from({ length: 11 }).map((_, index) => ({
  id: nowDate.getFullYear() - index + 1,
  name: nowDate.getFullYear() - index + 1,
}));

export const defaultDataMileage = Array.from({ length: 6 }, (_, i) => ({
  week: i + 1,
  odometerDist: 0,
  fuelCharge: 0,
  refuel: 0,
  personalDist: 0,
  workDist: 0,
  gpsDist: 0,
}));

export const defaultMonthMileage = {
  odometerDist: 0,
  fuel: 0,
};
